import { Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
    selector: "app-search-suggestions-dropdown",
    templateUrl: "./search-suggestions-dropdown.component.html",
    styleUrls: ["./search-suggestions-dropdown.component.scss"],
    standalone: false,
})
export class SearchSuggestionsDropdownComponent {
    @Input() suggestions: string[] = []
    @Input() isOpen: boolean = false
    @Input() activeIndex: number = -1
    @Input() showPopularHeading: boolean = false
    @Output() suggestionSelected = new EventEmitter<string>()

    onSelect(suggestion: string): void {
        this.suggestionSelected.emit(suggestion)
    }

    capitalizeFirstLetter(text: string): string {
        if (!text) {
            return text
        }
        return text.charAt(0).toUpperCase() + text.slice(1)
    }

    isLastSuggestion(index: number): boolean {
        return index === this.suggestions.length - 1
    }
}
